import React from 'react';
import { Check } from 'react-bootstrap-icons';

import { CheckBox as CheckBoxStyled, CheckBoxItem, Label } from './CheckBoxStyled';

type Props = {
  checked?: boolean;
  disabled?: boolean;
  onClick: (isChecked: boolean) => void;
};

export const CheckBox: React.FC<Props> = ({ checked = false, disabled = false, children, onClick }) => {
  return (
    <CheckBoxStyled>
      <CheckBoxItem tabIndex="0" checked={checked} disabled={disabled} onClick={() => onClick(!checked)}>
        {checked && <Check />}
      </CheckBoxItem>
      <Label onClick={() => onClick(!checked)}>{children}</Label>
    </CheckBoxStyled>
  );
};